export const environment = {
    production: false,
    ApiBaseUrl: "https://appsvc-remitter-toolsapi-dev2.azurewebsites.net/",
    EtlApiBaseUrl: "https://appsvc-remitter-etlapi-dev2-g6c4gddeazfgb3da.westus-01.azurewebsites.net/",
    CreditorPortalApiBaseUrl: "https://creditorportal-api-dev2.remitter.com/"
};
